class Announcement {
  constructor() {
    this.element = document.querySelector("[data-announcement]")
    if (!this.element) {
      return
    }

    // Attach event to close button
    document.querySelector("[data-announcement-hide]").addEventListener("click", () => this.onClose())
  }

  /**
   * On close button click
   */
  onClose() {
    // Make the element hidden
    this.element.setAttribute("data-hidden", "true")
    this.element.classList.add("d-none")
    // Set session cookie
    this.close()
  }

  /**
   * Create a session cookie
   */
  close() {
    document.cookie = `CSNZ_Announcement=${this.element.dataset.announcement};path=/`
  }
}

export default Announcement
